'use strict';

import $ from 'jquery';
import 'slick-carousel';

export default class MasonryPopup {
	constructor($selector) {
		this.$carouselImages = $('.masonry-gallery__carousel--images', $selector);
		this.$carouselNav = $('.masonry-gallery__carousel--nav', $selector);
		this.$close = $('.masonry-gallery__carousel--close button', $selector);

		this.$close.on('click', (e) => {
			e .preventDefault();

			$('.masonry-gallery__popup', $selector).removeClass('active');
			$('body').removeClass('fixed');
		});

		const galleryID = this.$carouselImages.attr('id');
    const navID = this.$carouselNav.attr('id');

		this.$carouselImages.slick({
			lazyLoad: 'ondemand',
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			fade: true,
			asNavFor: `#${navID}`,
			prevArrow: '<button type="button" class="slick-prev prev"><i class="icon-arrow-left"></i></button>',
			nextArrow: '<button type="button" class="slick-next next"><i class="icon-arrow-right"></i></button>'
		});

		this.$carouselNav.slick({
			slidesToShow: 10,
			slidesToScroll: 1,
			asNavFor: `#${galleryID}`,
			arrows: false,
			dots: false,
			focusOnSelect: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 7
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 5
					}
				},
				{
					breakpoint: 540,
					settings: {
						slidesToShow: 3
					}
				}
			]
		});
	}

	goToSlide(index) {
		console.log(index);
		this.$carouselImages.slick('slickGoTo', index);
	}
}
